import * as actionTypes from 'shared/state/auth/actionTypes';

export const authReducer = (state, action) => {
    switch (action.type) {
        case actionTypes.FETCH_USER:
            return {
                ...state,
                ...action.payload
            };
        case actionTypes.LOGGED_IN_USER:
            return {
                ...state,
                user: action.payload
            };
        case actionTypes.LOGOUT_USER:
            return {
                ...state,
                ...action.payload
            };
        default:
            return  {
                ...state,
                error: false,
            };
    }
};
